import * as $ from 'jquery';
import * as ko from 'knockout';

namespace PricingGuide {
    const GET_PRICING_URL = '/api/product';

    class PriceInfo {
        p: number;
        c: string;
    }

    class ComponentInfo extends PriceInfo {
        id: string;
        name: string;
        descr: string;
    }

    class PricingInfo {
        productName: string;
        basePrice: PriceInfo;
        components: ComponentInfo[];

        static get(): Promise<PricingInfo> {
            var promise: Promise<PricingInfo> = $.getJSON(GET_PRICING_URL);
            return promise;
        }
    }

    class Component {
        constructor(public name: string, public price: string, public description: string) { }
    }

    var knownCompomentDescriptions = {
        'deltahedger': 'См. <a href="http://docs.itglobal.ru/x/2ABk" target="_blank" rel="noopener">Дельта-хеджер (Delta Hedger)</a>',
        'marketmaker': 'См. <a href="http://docs.itglobal.ru/x/JQNk" target="_blank" rel="noopener">Маркет-мэйкер (Market Maker)</a>',
        'fos': 'См. <a href="http://docs.itglobal.ru/x/0gJk" target="_blank" rel="noopener">Лесенка заявок (Futures Ordres Stairs)</a>'
    };

    export class ViewModel {
        constructor() {            
            PricingInfo.get()
                .then(info => {
                    this.isBusy(false);
                    this.currency(info.basePrice.c);
                    this.basePrice(this.formatPrice(info.basePrice.p));

                    for (let i in info.components) {
                        const c = info.components[i];
                        if (c.p <= 0) {
                            continue;
                        }
                        this.components.push(new Component(c.name,
                            this.formatPrice(c.p),
                            knownCompomentDescriptions[c.id]));
                    }
                })
                .catch(e => {
                    this.isBusy(false);
                    this.errorMessage('Unable to fetch pricing info');
                });
        }

        isBusy = ko.observable<boolean>(true);
        errorMessage = ko.observable<string>();
        hasErrorMessage = ko.pureComputed(() => !!this.errorMessage());

        basePrice = ko.observable<string>();
        currency = ko.observable<string>();
        components = ko.observableArray<Component>();

        private formatPrice(p: number): string {
            var c = this.currency();

            switch (c) {
                case 'RUB':
                    return p.toString() + '&nbsp;&#x20bd;';
                case 'USD':
                    return '$' + p.toString();
                default:
                    return p.toString() + ' ' + c;
            }
        }
    }
}

export default function createPricingGuide(element: HTMLElement) {
    var viewModel = new PricingGuide.ViewModel();
    ko.applyBindingsToDescendants(viewModel, element);
}

window['createPricingGuide'] = createPricingGuide;